import React from 'react'
import ContactForm from '../components/ContactForm'
import { AnimatedPage } from '../components/AnimatedPage'

export const Contact = () => {
  return (
    <AnimatedPage>
    
    <ContactForm/>
    </AnimatedPage>
  )
}
